import {
    FETCH_RAINPRO_STORAGES,
    CLEAN_RAINPRO_STORAGES,
    DELETE_RAINPRO_STORAGE,
    CHANGE_RAINPRO_STORAGE,
} from '../actions/types';
import _ from "lodash";
import {toNumber} from "../functions";

const RAINPRO_STORAGES_DEFAULT_STATE = {};

const RainproStoragesReducer = (state = RAINPRO_STORAGES_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_RAINPRO_STORAGES:
            return payload;

        case CHANGE_RAINPRO_STORAGE:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, ...payload.data };
                }

                return item;
            }) };

        case CLEAN_RAINPRO_STORAGES:
        case DELETE_RAINPRO_STORAGE:
            return RAINPRO_STORAGES_DEFAULT_STATE;

        default:
            return state;
    }
};

export default RainproStoragesReducer;
